module.exports = __webpack_public_path__ + "img/lock.fbfe4434.svg";